import { render, staticRenderFns } from "./ChatBotLineSettings.vue?vue&type=template&id=64352b73&scoped=true&"
import script from "./ChatBotLineSettings.vue?vue&type=script&lang=js&"
export * from "./ChatBotLineSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotLineSettings.vue?vue&type=style&index=0&id=64352b73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64352b73",
  null
  
)

export default component.exports